import { VerticalContainer } from '@american-autonomy/ag-ui';

import DetailsViewEntityLink from 'components/DetailsViewEntityLink';
import DetailsViewEntityLinkContainer from 'components/DetailsViewEntityLinkContainer';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const ChemicalDetailFields: FunctionComponent<Props> = ({
    classification,
    epaNumber,
    formulation,
    manufacturer,
    modeOfAction,
    ppe,
    ppeReentry,
    rainfastness,
    rei,
    signalWord,
    testId = TEST_ID
}) => (
    <VerticalContainer testId={testId}>
        <DetailsViewEntityLinkContainer>
            <DetailsViewEntityLink entityName={epaNumber ?? '-'} entityType='epaNumber' />

            <DetailsViewEntityLink entityName={manufacturer ?? '-'} entityType='manufacturer' />

            <DetailsViewEntityLink entityName={classification} entityType='classification' />

            <DetailsViewEntityLink entityName={signalWord ?? '-'} entityType='signalWord' />

            <DetailsViewEntityLink entityName={formulation ?? '-'} entityType='formulation' />

            <DetailsViewEntityLink entityName={rei} entityType='rei' />

            <DetailsViewEntityLink entityName={rainfastness} entityType='rainfastness' />

            <DetailsViewEntityLink entityName={modeOfAction} entityType='modeOfAction' />

            <DetailsViewEntityLink entityName={ppe ?? '-'} entityType='ppe' />

            <DetailsViewEntityLink entityName={ppeReentry ?? '-'} entityType='ppeReentry' />
        </DetailsViewEntityLinkContainer>
    </VerticalContainer>
);

export default ChemicalDetailFields;
